module.exports = __webpack_public_path__ + "static/media/logo-inverted.24340b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/components/logo-inverted.svg
// module id = 1887
// module chunks = 0